import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PageNotFound from "./pages/PageNotFound";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ForgotPassword/ResetPassword";
import EmailSent from "./pages/ForgotPassword/EmailSent";
import TermsAndConditions from "./pages/UserAgreement/TermsAndConditions";
import PrivacyAndPolicy from "./pages/UserAgreement/PrivacyAndPolicy";
import EmailVerification from "./pages/EmailVerification/EmailVerification";
import PasswordResetSuccess from "./pages/ForgotPassword/PasswordResetSuccess";
import SignUpSuccess from "./pages/EmailVerification/SignUpSuccess";
import UserProfile from "./pages/UserDetails/UserProfile";
import Home from "./components/Layout/Home";
import SendOTPAndVerifyEmail from "./pages/OTPEmailVerification/SendOTPAndVerifyEmail";
import SendOTPAndVerifyPhone from "./pages/OTPPhoneVerification/SendOTPAndVerifyPhone";
import OTPVerifiedSuccess from "./pages/OTPEmailVerification/OTPVerifiedSuccess";
import ChangePassword from "./pages/UserDetails/ChangePassword";
import ContactUs from "./pages/UserDetails/ContactUs";
import AboutUs from "./pages/UserDetails/AboutUs";
import CategoryManagement from "./pages/UserDetails/CategoryManagement";
import BudgetManagement from "./pages/UserDetails/BudgetManagement";
import BillManagement from "./pages/UserDetails/BillManagement";
import GroupManagement from "./pages/UserDetails/GroupManagement";
import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import AdminLogin from "./pages/AdminDashboard/AdminLogin";
import RequestForAdminAccess from "./pages/AdminDashboard/RequestForAdminAccess";
import GoogleAuthSuccess from "./pages/GoogleAuthSuccess";
import { ThemeProvider } from "./contexts/ThemeContext";
import TokenManager from "./components/common/TokenManager";

function App() {
  return (
    <ThemeProvider>
      <TokenManager>
        <Routes>
        <Route
          path="/user"
          element={
            <ProtectedRoutes>
              <HomePage />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/user/user-profile"
          element={
            <ProtectedRoutes>
              <UserProfile />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/user/change-password"
          element={
            <ProtectedRoutes>
              <ChangePassword />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/user/categories"
          element={
            <ProtectedRoutes>
              <CategoryManagement />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/user/budgets"
          element={
            <ProtectedRoutes>
              <BudgetManagement />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/user/bills"
          element={
            <ProtectedRoutes>
              <BillManagement />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/user/groups"
          element={
            <ProtectedRoutes>
              <GroupManagement />
            </ProtectedRoutes>
          }
        />
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/signup-success" element={<SignUpSuccess />} />
        <Route
          path="/email-verification/:expenseAppUserId/:token"
          element={<EmailVerification />}
        />
        <Route path="/login" element={<Login />} />
        <Route path="/google-auth-success" element={<GoogleAuthSuccess />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-email-sent" element={<EmailSent />} />
        <Route
          path="/reset-password/:expenseAppUserId/:token"
          element={<ResetPassword />}
        />
        <Route
          path="/password-reset-success"
          element={<PasswordResetSuccess />}
        />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyAndPolicy />} />
        {/* send otp and verify email */}
        <Route
          path="/email-otp-verification"
          element={<SendOTPAndVerifyEmail />}
        />
        {/* Send OTP and verify phone */}
        <Route
          path="/phone-otp-verification"
          element={<SendOTPAndVerifyPhone />}
        />
        <Route path="/otp-verified-success" element={<OTPVerifiedSuccess />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/request-access" element={<RequestForAdminAccess />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        {/* if path is not correct then navigate to page not found page */}
        <Route path="*" element={<PageNotFound />} />
        </Routes>
      </TokenManager>
    </ThemeProvider>
  );
}

export function ProtectedRoutes(props) {
  if (localStorage.getItem("user")) {
    return props.children;
  } else {
    return <Navigate to="/" />;
  }
}

export default App;
